import React, { useEffect, useState } from "react";
import styled from "styled-components";
import "aos/dist/aos.css";
import emailjs from "@emailjs/browser";
import Fade from "react-reveal/Fade";
function Contact({ ContactRef, setActiveTab, activeTab }) {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [phone, setPhone] = useState("");
  useEffect(() => {
    emailjs.init("CTHppUA2i2Miqwkii");
  }, []);

  const contactUs = (e) => {
    if (
      firstName.length > 0 &&
      lastName.length > 0 &&
      email.length > 0 &&
      subject.length > 0 &&
      message.length > 0
    ) {
      emailjs
        .send("service_rzb9t7n", "template_5xnrk7e", {
          from_first_name: firstName,
          from_last_name: lastName,
          from_email: email,
          from_phone: phone,
          from_subject: subject,
          message: message,
        })
        .then((result) => {
          alert("Mail sent Successfully!");
          setEmail("");
          setFirstName("");
          setLastName("");
          setSubject("");
          setPhone("");
          setMessage("");
        })
        .catch((err) => console.log(err));
    } else {
      alert("Please fill up the form properly.");
    }
  };

  return (
    <Fade bottom>
      <Container ref={ContactRef}>
        <Title>
          <h2>Get In Touch</h2>
        </Title>
        <Main>
          <Form>
            <FirstInput>
              <input
                type="text"
                placeholder="First Name"
                onChange={(e) => setFirstName(e.target.value)}
                value={firstName}
              />
              <input
                type="text"
                placeholder="Last Name"
                onChange={(e) => setLastName(e.target.value)}
                value={lastName}
              />
            </FirstInput>
            <FirstInput>
              <input
                type="email"
                placeholder="Email"
                onChange={(e) => setEmail(e.target.value)}
                value={email}
              />
              <input
                type="text"
                placeholder="Phone (Optional)"
                onChange={(e) => setPhone(e.target.value)}
                value={phone}
              />
            </FirstInput>
            <SecondInput>
              <input
                type="text"
                placeholder="Subject"
                onChange={(e) => setSubject(e.target.value)}
                value={subject}
              />
            </SecondInput>
            <ThirdInput>
              <textarea
                type="text"
                placeholder="Message (optional)"
                onChange={(e) => setMessage(e.target.value)}
                value={message}
              />
            </ThirdInput>

            <button onClick={contactUs}>Submit</button>
          </Form>
        </Main>
      </Container>
    </Fade>
  );
}
const Container = styled.div`
  width: 100%;

  height: 100vh;
  min-height: 800px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #fff;
`;

const Title = styled.div`
  font-size: 26px;
  margin-bottom: 40px;
`;
const Main = styled.div`
  width: 80%;

  display: flex;
  align-items: center;
  justify-content: space-evenly;
  @media only screen and (max-width: 1012px) {
    flex-direction: column;
  }
`;

const Form = styled.div`
  background-color: #ffffff;
  border-radius: 15px;
  width: 70%;

  height: 450px;
  padding: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media only screen and (max-width: 1012px) {
    width: 100%;
  }

  button {
    width: 100px;
    height: 40px;
    border: none;
    outline: none;
    background-color: #c9a44e;
    color: #fff;
    font-weight: 600;
    border-radius: 5px;
    margin-top: 20px;
    align-self: center;
    margin-right: 23px;
    cursor: pointer;
  }
`;

const Box = styled.div`
  background-color: #ffffff;
  padding: 10px;
  width: 180px;
  height: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border-radius: 15px;
  margin-top: 20px;
  @media only screen and (max-width: 1012px) {
    width: 150px;
    img {
      width: 35px !important;
    }

    h4 {
      font-size: 15px !important;
    }

    p {
      font-size: 12px !important;
    }
  }
  img {
    width: 50px;

    margin-bottom: 10px;
  }

  h4 {
    margin-bottom: 5px;
    font-size: 20px;
  }

  p {
    font-size: 15px;
    color: #808080;
  }
`;

const FirstInput = styled.div`
  display: flex;
  flex-direction: row;
  width: 92%;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
  input {
    height: 33px !important;
    background: #ececec !important;
    border-radius: 5px !important;
    width: 48% !important;
    padding: 5px !important;
    border: none !important;
    outline: none !important;
    margin-top: 00px;
    margin-right: 10px;
  }
`;

const SecondInput = styled.div`
  display: flex;
  flex-direction: row;
  width: 92%;
  align-items: center;
  margin-top: 10px;
  justify-content: space-between;

  input {
    height: 33px !important;
    background: #ececec !important;
    border-radius: 5px !important;
    width: 100% !important;
    padding: 5px !important;
    border: none !important;
    outline: none !important;
    margin-top: 00px;
    margin-right: 10px;
  }
`;

const ThirdInput = styled.div`
  display: flex;
  flex-direction: row;
  width: 92%;
  align-items: center;
  margin-top: 20px;
  justify-content: space-between;

  textarea {
    background: #ececec !important;
    border-radius: 5px !important;
    width: 100% !important;
    padding: 10px !important;
    border: none !important;
    outline: none !important;
    margin-top: 00px;
    height: 200px;
    resize: none !important;
    margin-right: 10px;
  }
`;
export default Contact;
